import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector, batch } from "react-redux";
import useWebSocket from "react-use-websocket";
import { WEB_SOCKETS_URL } from "../configs/api.urls";
import { _pushNotification } from "../configs/common";
import { setPositions, setSocketConnection } from "../store/actions/group.action";

const WebSocket = ({ onConnection }) => {
  const dispatch = useDispatch();

  const isSocketConnected = useSelector(state => state.groupReducer.isSocketConnected);

  const { lastMessage, readyState } = useWebSocket(WEB_SOCKETS_URL, {
    share: true,
    shouldReconnect: () => true,
    reconnectAttempts: 10,
    reconnectInterval: 2000,
  });

  const latestRef = useRef({
    batchedPositions: [],
  });

  // Update ref whenever batchedPositions change
  useEffect(() => {
    if (lastMessage) {
      try {
        const data = JSON.parse(lastMessage.data);

        if (data.positions) {
          latestRef.current.batchedPositions = [...latestRef.current.batchedPositions];
          data.positions.forEach((pos) => {
            const idx = latestRef.current.batchedPositions.findIndex(p => p.deviceId === pos.deviceId);
            if (idx > -1) {
              latestRef.current.batchedPositions[idx] = pos;
            } else {
              latestRef.current.batchedPositions.push(pos);
            }
          });
        }

        // Handle events (optional notifications)
        if (data.events && data.events.length > 0) {
          const vehicles = JSON.parse(localStorage.getItem("__vehicles__") || "{}");
          data.events.forEach(event => {
            if (vehicles[event.deviceId]) {
              const msg = `Vehicle ${vehicles[event.deviceId].name} is ${event.type} now.`;
              _pushNotification(event.type, msg);
            }
          });
        }
      } catch (err) {
        console.error("Failed to parse WebSocket message", err);
      }
    }
  }, [lastMessage]);

  useEffect(() => {
    const interval = setInterval(() => {
      const { batchedPositions } = latestRef.current;
      if (batchedPositions.length > 0) {
        batch(() => {
          dispatch(setPositions(batchedPositions, !isSocketConnected));

          if (!isSocketConnected) dispatch(setSocketConnection());
        });

        latestRef.current.batchedPositions = [];

        if (onConnection) onConnection(true);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [dispatch, isSocketConnected, onConnection]);

  // Handle readyState (optional, e.g., redirect if disconnected)
  useEffect(() => {

    // if (readyState === 1 && !isSocketConnected) {
    //   dispatch(setSocketConnection());
    // }

    if (readyState === 3) {
      // Example: redirect to login if needed
      // if (!window.location.origin.includes("localhost")) {
      //   window.location.href = "/login";
      // }
    }
  }, [readyState]);

  return null;
};

export default WebSocket;
